"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// helper function to remove (Ships every ... Days) text from title
// mainly in vitamin bundle titles
exports.default = (function (input) { return input.replace(/\s*\(Ships every .+?\)/, ''); });
